import React from "react";
import { Link } from "react-router-dom";

import "./NoMatch.scss";

export class NoMatch extends React.Component {
  render() {
    return (
      <div className="NoMatch">
        <h1>404</h1>
        <h2>We could not find the page you are looking for!</h2>
        <Link to="/">Go Back to Dashboard</Link>
      </div>
    );
  }
}
